export const uploadImage = (axiosInstance, data) => {
    const f = new FormData();
    f.append('File', data.file);
    f.append('Extension', data.extension);
    f.append('Orientation', data.orientation);
    return axiosInstance.post(`v1/upload/image`, f,
        {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
};

// player profile

export const removePlayerProfilePhoto = (axiosInstance, playerId) => {
    return axiosInstance.post(`v1/player/images/profile/delete?playerId=${playerId}`, {});
};

export const removePlayerBannerPhoto = (axiosInstance, playerId) => {
    return axiosInstance.post(`v1/player/images/profile/deletebanner?playerId=${playerId}`, {});
};

export const submitPlayerProfilePhotoCrop = (axiosInstance, playerId, data) => {
    return axiosInstance.post(`v1/player/images/profile/update?playerId=${playerId}`, data);
};

export const submitPlayerProfileBannerCrop = (axiosInstance, playerId, data) => {
    return axiosInstance.post(`v1/player/images/profile/updateBanner?playerId=${playerId}`, data);
};

// club profile

export const submitClubProfilePhotoCrop = (axiosInstance, clubId, data) => {
    return axiosInstance.post(`v1/club/images/profile/updateprofile?clubId=${clubId}`, data);
};

export const removeClubProfilePhoto = (axiosInstance, clubId) => {
    return axiosInstance.post(`v1/club/images/profile/deleteprofile?clubId=${clubId}`, {});
};

export const removeClubBannerPhoto = (axiosInstance, clubId) => {
    return axiosInstance.post(`v1/club/images/profile/deletebanner?clubId=${clubId}`, {});
};

export const submitClubBannerCrop = (axiosInstance, clubId, data) => {
    return axiosInstance.post(`v1/club/images/profile/updatebanner?clubId=${clubId}`, data);
};

export const submitClubSponsorLogoCrop = (axiosInstance, clubId, data) => {
    return axiosInstance.post(`v1/club/images/profile/updatesponsorlogo?clubId=${clubId}`, data);
};

export const removeClubSponsorLogo = (axiosInstance, clubId) => {
    return axiosInstance.post(`v1/club/images/profile/deletesponsorlogo?clubId=${clubId}`, {});
};

export const submitClubSponsorLogo = (axiosInstance, clubId, data) => {
    return axiosInstance.post(`v2/tms/events/${clubId}/images/sponsorlogos`, data);
};
// event profile

export const removeEventBannerPhoto = (axiosInstance, eventId) => {
    return axiosInstance.post(`v1/tms/events/images/profile/deletebanner?eventId=${eventId}`, {});
};

export const submitEventBannerCrop = (axiosInstance, eventId, data) => {
    return axiosInstance.post(`v1/tms/events/images/profile/updatebanner?eventId=${eventId}`, data);
};
